import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';
import { CampaignFilterIds } from 'pages/Campaigns/constants/filters';
import { getCampaignFilterLabel } from 'modules/campaigns/utils/getCampaignFilterLabel';
import { Option } from 'common/types';

export const useInitialCampaignFilters = ({
  userOrganizationOptions
}: {
  userOrganizationOptions: Option[];
}) => {
  const [searchParams] = useSearchParams();

  const initialFilters = useMemo(() => {
    const statusFilter = searchParams.get(CampaignFilterIds.status) || '';
    const needsReviewFilter =
      searchParams.get(CampaignFilterIds.needsReview) || '';
    const createdByFilter = searchParams.get(CampaignFilterIds.createdBy) || '';
    const createdByUserOrganizationOption = userOrganizationOptions.find(
      (options) => options.value === createdByFilter
    );

    // needsReview now carries either "true" (Review) or
    // "MORE_TIME_REQUESTED" — same column dropdown, two options.
    const needsReviewValue: boolean | string =
      needsReviewFilter === 'MORE_TIME_REQUESTED'
        ? 'MORE_TIME_REQUESTED'
        : needsReviewFilter === 'true';

    const filters = [
      {
        filterId: CampaignFilterIds.status,
        value: statusFilter,
        label: getCampaignFilterLabel(CampaignFilterIds.status, statusFilter)
      },
      {
        filterId: CampaignFilterIds.needsReview,
        value: needsReviewValue,
        label: getCampaignFilterLabel(
          CampaignFilterIds.needsReview,
          needsReviewValue
        )
      }
    ];

    if (createdByUserOrganizationOption) {
      filters.push({
        filterId: CampaignFilterIds.createdBy,
        value: createdByUserOrganizationOption.value,
        label: createdByUserOrganizationOption.label
      });
    }

    return filters.filter((filter) => !!filter.value);
  }, [searchParams, userOrganizationOptions]);

  return initialFilters;
};
